import { render, staticRenderFns } from "./StudentFilters.vue?vue&type=template&id=f08b130c&scoped=true"
import script from "./StudentFilters.vue?vue&type=script&lang=js"
export * from "./StudentFilters.vue?vue&type=script&lang=js"
import style0 from "./StudentFilters.vue?vue&type=style&index=0&id=f08b130c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f08b130c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VListItemAvatar } from 'vuetify/lib/components/VList';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VListItemAvatar,VListItemContent,VListItemTitle,VTextField})
